import { instanceCoveryt, instanceFalyt } from './axiosConfig'

export default {
  // Call account api to find user details
  async getLicensePlateCoverForImage(data) {
    const url = `/v1/plate/corners`

    return await instanceCoveryt.post(url, data)
  },

  async croppedImage(data, type) {
    let url
    const urlCrop = '/v1/processes/crop'
    const urlPartialCrop = '/v1/processes/crop-partial'
    const urlFadedCrop = '/v1/processes/crop-fading'

    if (type === 'CROPPING') url = urlCrop
    if (type === 'PARTIAL_CROPPING') url = urlPartialCrop
    if (type === 'FADED_CROPPING') url = urlFadedCrop

    try {
      return await instanceFalyt.post(url, data)
    } catch (err) {
      return null
    }
  }
}
